import Vue from "vue";
import {
    rtdbPlugin
} from "vuefire";

Vue.use(rtdbPlugin);